import React, { useEffect, useState } from "react";
import Table from "../../../../../components/coreUiTable/Table";
import { cuFormat, calculateTotals } from "../../../../../components/coreUiTable/Format";
import PropTypes from "prop-types";

const ReferralBreakdownTable = ({ table, sourceType, isRowHouse = false }) => {
  const [filteredData, setFilteredData] = useState([]);
  const [totalWidths, setTotalWidths] = useState([]);
  const [col1Total, setCol1Total] = useState(0);
  const showTotals = table.data.length > 0 && sourceType === "clubready";

  // we need reference to each thead.tr in table to their get widths
  const children = document.getElementById("referralBreakdown")?.querySelector("tr")?.children;

  useEffect(() => {
    if (showTotals) {
      // if rendered get children's widths on each filter (render)
      if (children) {
        const newtWidths = [];
        for (let i = 0; i < children.length; i++) {
          newtWidths.push(children[i].offsetWidth);
        }

        setTotalWidths(newtWidths.splice(1));
      }

      // if Row House recalculate second column on each filter (render)
      if (isRowHouse) {
        setCol1Total(
          filteredData.map((row) => row[table.colHeaders[1]]).reduce((acc, res) => acc + res, 0)
        );
      }
    }
  }, [filteredData]);

  //TODO: remove this workaround when backend will send proper data on Row House
  if (isRowHouse && showTotals) {
    table = {
      ...table,
      data: table.data.map((row) => {
        row[2] = row[1] / col1Total;
        return row;
      })
    };
  }

  // Format all values according to columns array
  const formattedSlots = cuFormat({
    headers: table.colHeaders,
    // TODO: ask backend to change api accordingly in order to avoid workaround
    columns: table.columns.map((col) =>
      col.numericFormat ? { ...col, format: col.numericFormat.pattern } : col
    ),
    links: table.links
  });

  return (
    <Table
      tableWrapperId={"referralBreakdown"}
      table={table}
      sorter={true}
      pagination={false}
      scopedSlots={formattedSlots}
      onFilteredItemsChange={(data) => setFilteredData(data)}
      underTableSlot={
        showTotals ? (
          <table className="table coreUiTable" id="under-table-slot">
            <tbody>
              <tr className="">
                <td style={{ fontWeight: "700" }}>Total</td>
                {/*Using formattedSlots to get formats for totals as well*/}
                {table.colHeaders.slice(1).map((header, index) => {
                  // formattedSlots is an object with header names as properties
                  // and callback render functions as values, thus formattedSlots[header]
                  // is a function which may receive two arguments 'function(value, tdStyles)'.
                  // Code below basically returns '<td styles={{...tdStyles}}>{formatted(value)}</td>'.
                  const renderFunc = formattedSlots[header];

                  // style for current column tds
                  const tdStyle = { width: `${totalWidths[index]}px` };

                  // raw value for totals row after performing calculations
                  const value = {
                    [header]: calculateTotals(
                      filteredData,
                      table.rowCalculations[index + 1],
                      table.colHeaders,
                      header
                    )
                  };

                  return renderFunc(value, tdStyle);
                })}
              </tr>
            </tbody>
          </table>
        ) : null
      }
    />
  );
};

export default ReferralBreakdownTable;

ReferralBreakdownTable.propTypes = {
  table: PropTypes.object,
  sourceType: PropTypes.string,
  isRowHouse: PropTypes.bool
};
